import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import SitesTable from "./AllSitesTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const AllSites = ({ isAdmin }) => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    sites: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Sites")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          sites: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <SitesTable
            data={dataObj.sites}
            title={"All Sites"}
            isAdmin={isAdmin}
          />
        </div>
      )}
    </>
  );
};

export default AllSites;
